import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Frame186.png'


const _withScopeId = n => (_pushScopeId("data-v-df5c862e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "society d-flex flex-column flex-md-row" }
const _hoisted_2 = { class: "society-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "Join Halal as a Cooperative Soicety", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "para" }, " Halal is a new type of financing platform that offers zero interest loans to individuals and business entities. If you are a cooperative society, joining Halal gives you an added advantage as your members get get loans faster and more easily at zero interest rate. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "society-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "socity",
    class: "w-100 h-100"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_router_link, { to: "/our-culture" }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, {
            svg: "",
            icon: "arrow-right",
            name: "Jon us now",
            type: "blue"
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_5
  ]))
}